"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TCell_1 = require("./TCell");
var TLastRowHintCell = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(TCell_1.default, __assign({}, props, { className: "oui-table__last-row-hint" }),
        React.createElement("div", { className: "oui-flex oui-flex-center oui-flex-middle" }, children)));
};
exports.default = TLastRowHintCell;
//# sourceMappingURL=TLastRowHintCell.js.map